import React, { useState, useEffect } from 'react';
import styles from './Profile.module.css';
import { useAuth } from '../Context/Auth';

export default function Profile() {
  const { user, logoutUser, isLoggedIn } = useAuth();
  const [avatar, setAvatar] = useState('');

  // لما المكون يتحمل، نشوف إذا فيه صورة محفوظة في localStorage
  useEffect(() => {
    const storedAvatar = localStorage.getItem('userAvatar');
    if (storedAvatar) {
      setAvatar(storedAvatar);
    } else if (user?.avatar) {
      setAvatar(user.avatar);
    }
  }, [user]);

  // دالة تغيير الصورة
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setAvatar(reader.result);
        localStorage.setItem('userAvatar', reader.result); // نحفظ الصورة في localStorage
      };
      reader.readAsDataURL(file);
    }
  };

  // دالة مسح الصورة
  const handleRemoveImage = () => {
    setAvatar('');
    localStorage.removeItem('userAvatar'); // نحذف الصورة من localStorage
  };

  if (!isLoggedIn || !user) {
    return (
      <div className={styles.noUser}>
        <h2>You are not logged in</h2>
      </div>
    );
  }

  const userEntries = Object.entries(user);
  const excludedKeys = ['AccessToken', 'ExpiresAt'];

  return (
    <div className={styles.profileContainer}>
      <div className={styles.profileCard}>
        <div className={styles.profileImage}>
          <img 
            src={avatar || `https://ui-avatars.com/api/?name=${user.fullName}`} 
            alt={user.fullName} 
          />
          <input 
            type="file" 
            accept="image/*" 
            onChange={handleImageChange} 
            className={styles.fileInput}
          />
          {avatar && (
            <button className={styles.removeBtn} onClick={handleRemoveImage}>
              Remove
            </button>
          )}
        </div>
        <div className={styles.profileInfo}>
          <h2 className={styles.name}>{user.fullName}</h2>

          {userEntries
            .filter(([key]) => !excludedKeys.includes(key))
            .map(([key, value]) => (
              <p key={key}>
                <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong> {value || 'N/A'}
              </p>
          ))}

          <button className={styles.logoutBtn} onClick={logoutUser}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}
